<template>

  <div style="text-align:left">

    <div v-for="(item, i) in refs" :key="i" class="item">

      <div v-if="item.raw !== undefined">
        [{{i+1}}] {{item.raw}}
      </div>


      <div v-else>
        [{{i+1}}]
        <span v-if="item.title !== '' && item.title != null">"{{item.title}}",  {{item.org}}. </span>
        <a :href="item.url" target="_blank">{{item.url}}</a>
      </div>



    </div>

  </div>
</template>

<script>

   /**
    * the refs array should have form  [{title, url, date, org, ref, raw}].
    * if the raw prop is included, then the others are ignored.
    *
    */

   export default {
      name: "reference",

      props:{
         refs: Array,
      },

      computed: {
         refs_hash(){



            this.refs.sort((a, b) => (a.title > b.title) ? 1 : -1);

            let hash = {};
            for (let i=0; i<this.refs.length; i++){
               hash[this.refs[i].ref] = i;
            }
            return hash;

         }
      },
      created(){

      }
   }
</script>

<style scoped>

  .item{
    font-size: 0.8em;
    padding-bottom: 10px;
  }

</style>